export class Auth0Config {
  public readonly clientId: string;
  public readonly domain: string;
  public readonly audience: string;
  public readonly tenant: string;
  public readonly tokenIssuer: string;

  constructor(
    clientId: string,
    domain: string,
    audience: string,
    tenant: string,
    tokenIssuer: string
  ) {
    this.clientId = clientId;
    this.domain = domain;
    this.audience = audience;
    this.tenant = tenant;
    this.tokenIssuer = tokenIssuer;
  }

  static parse(obj: any) {
    if (!obj) return;

    return new Auth0Config(obj.clientId, obj.domain, obj.audience, obj.tenant, obj.tokenIssuer);
  }
}
